<template>
  <avz-users />
</template>

<script>
import Users from '@/components/Users'

export default {
  components: {
    'avz-users': Users
  }
}
</script>
